
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`isStyledComponent`}</inlineCode></h3>
    <p>{`A utility to help identify styled components.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">Function</Code>
    </Column>
    <Column mdxType="Column">
      Any function expected to possibly be a styled component or React component
      wrapped in a styled component
    </Column>
  </Row>
    </Table>
    <p>{`Returns true if the passed function is a valid styled components-wrapped component class. It can be useful for determining if a component needs to be wrapped such that it can be used as a component selector:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import styled, { isStyledComponent } from 'styled-components'
import MaybeStyledComponent from './somewhere-else'

let TargetedComponent = isStyledComponent(MaybeStyledComponent)
  ? MaybeStyledComponent
  : styled(MaybeStyledComponent)\`\`

const ParentComponent = styled.div\`
  color: cornflowerblue;

  \${TargetedComponent} {
    color: tomato;
  }
\`
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;